import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m19.555 7.22-6.117 7.342-1.83-1.83 3.524-4.23a1 1 0 0 0-1.537-1.28l-6.117 7.34-3.316-3.316a1 1 0 0 0-1.415 1.414l4.091 4.091a1 1 0 0 0 1.476-.067l2.008-2.41 2.476 2.476a1 1 0 0 0 1.475-.067l6.819-8.182a1 1 0 1 0-1.537-1.28"
    }, null, -1)
  ])))
}
export default { render: render }